<template>
  <div class="survey-cake-page" :class="{ 'pdf-mode': isPDF }">
    <img src="@/assets/survey-cake/logo.png" class="logo" />
    <div class="result-page">
      <div class="page-title">
        <img src="@/assets/survey-cake/star-icon.png" class="star-icon" />
        <h3 class="GenSenRounded">
          {{ truncatedName }} 的超能力組合出爐，一起來回顧你的亮點吧！
        </h3>
      </div>
      <div class="result-contain">
        <div class="radar-contain">
          <RadarChart
            v-if="resultScore && resultScore.length > 0"
            :resultScore="resultScore"
            :isPDF="isPDF"
          />
        </div>
        <div
          v-for="item in classifiedScore"
          :key="item.id"
          class="result-card"
          :class="{ hidden: item.class.length === 0 }"
        >
          <div class="classified-title GenSenRounded">
            {{
              item.id === 1
                ? "這次 DFC 行動中，你最常運用的超能力"
                : item.id === 2
                ? "你還展現了以下這些會繼續長大的超能力"
                : "未來你有很多機會發揮，只是這次較少使用的超能力"
            }}
          </div>
          <div class="classified-tabs">
            <div v-for="tab in item.class" :key="tab" class="classified-tab">
              <img
                v-if="tab === '語文智能'"
                src="@/assets/survey-cake/icon-language-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '邏輯數學智能'"
                src="@/assets/survey-cake/icon-math-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '視覺空間智能'"
                src="@/assets/survey-cake/icon-eye-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '肢體動覺智能'"
                src="@/assets/survey-cake/icon-limbs-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '音樂智能'"
                src="@/assets/survey-cake/icon-music-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '內省智能'"
                src="@/assets/survey-cake/icon-self-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '人際智能'"
                src="@/assets/survey-cake/icon-interpersonal-tab.png"
                class="tab-icon"
              />
              <img
                v-if="tab === '自然智能'"
                src="@/assets/survey-cake/icon-nature-tab.png"
                class="tab-icon"
              />
              <!-- <div class="tab-name GenSenRounded">{{ tab }}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadarChart from "./RadarChart.vue";

export default {
  name: "ResultPage",
  components: {
    RadarChart,
  },
  props: {
    name: {
      type: String | null,
      required: true,
    },
    classifiedScore: {
      type: Array,
      required: true,
    },
    resultScore: {
      type: Array,
      required: true,
    },
    isPDF: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    truncatedName() {
      if (!this.name) {
        return "";
      }
      const maxWidth = 18;
      let currentWidth = 0;
      let result = "";

      for (let i = 0; i < this.name.length; i++) {
        const char = this.name[i];
        let charWidth;

        if (/[\u4e00-\u9fff]/.test(char)) {
          // 中文字符
          charWidth = 2;
        } else if (/[A-Z]/.test(char)) {
          // 大寫英文
          charWidth = 1.63;
        } else if (/[a-z]/.test(char)) {
          // 小寫英文
          charWidth = 1.28;
        } else if (/[0-9]/.test(char)) {
          // 數字
          charWidth = 1.28;
        } else {
          // 其他符號
          charWidth = 2;
        }

        if (currentWidth + charWidth > maxWidth) {
          result += "...";
          break;
        }

        result += char;
        currentWidth += charWidth;
      }

      return result;
    },
  },
};
</script>

<style scoped lang="scss">
.survey-cake-page {
  width: 100vw;
  height: calc((3508 / 2480) * 100vw);
  padding: 5.8% 7% 5%;
  background-color: #fae4cb;
  position: relative;
  .logo {
    position: absolute;
    top: 2%;
    right: 3%;
    width: 4.5%;
  }
  .result-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .page-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 2%;
  }
  .star-icon {
    width: 4.4%;
    margin-right: 1.5%;
  }
  h3 {
    color: #eb6165;
    font-size: 2.7vw;
    font-weight: 700;
    line-height: 1.2;
  }
  .result-contain {
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
    flex-wrap: nowrap;
    align-items: center;
  }
  .radar-contain {
    height: 40%;
    width: 100%;
    background-color: white;
    border-radius: 3.2vw;
    margin-bottom: 2%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2vw;
    box-sizing: border-box;
  }
  .result-card {
    width: 100%;
    background-color: white;
    border-radius: 3.2vw;
    padding: 2.3vw 3%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2%;
  }
  .result-card:nth-last-child(1) {
    margin-bottom: 0;
  }
  .classified-title {
    color: #eb6165;
    font-size: 2vw;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
    @media only screen and (max-width: 768px) {
      margin-bottom: 0.5rem;
    }
  }
  .classified-tabs {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
  }
  .classified-tab {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    @media only screen and (max-width: 768px) {
      margin-bottom: 0.5rem;
    }
  }
  .tab-icon {
    width: 23vw;
    margin-right: 0.7vw;
  }
  .tab-name {
    color: #1e1e1e;
    font-size: 2vw;
    font-weight: 300;
    line-height: 0;
  }
  .hidden {
    display: none;
  }
}
.survey-cake-page.pdf-mode {
  width: 2480px;
  height: 3508px;
  h3 {
    font-size: 67px;
  }
  .radar-contain {
    border-radius: 80px;
    padding: 50px;
  }
  .result-card {
    border-radius: 80px;
    padding: 57px 3%;
  }
  .classified-title {
    font-size: 50px;
    margin-bottom: 40px;
  }
  .classified-tab {
    margin-bottom: 30px;
  }
  .tab-icon {
    width: 570px;
    margin-right: 18px;
  }
  .tab-name {
    font-size: 50px;
  }
}
</style>
